import { render, staticRenderFns } from "./claimedit_youbaoxian.vue?vue&type=template&id=2feb3b95&scoped=true&"
import script from "./claimedit_youbaoxian.vue?vue&type=script&lang=js&"
export * from "./claimedit_youbaoxian.vue?vue&type=script&lang=js&"
import style0 from "./claimedit_youbaoxian.vue?vue&type=style&index=0&id=2feb3b95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb3b95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2feb3b95')) {
      api.createRecord('2feb3b95', component.options)
    } else {
      api.reload('2feb3b95', component.options)
    }
    module.hot.accept("./claimedit_youbaoxian.vue?vue&type=template&id=2feb3b95&scoped=true&", function () {
      api.rerender('2feb3b95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimedit_youbaoxian.vue"
export default component.exports